import { Table } from "antd"
import { useEffect, useState } from "react"
import { useQuery } from "react-query"
import { AxiosError } from "axios"
import Column from "antd/lib/table/Column"
import useOpus from "contexts/opus/hooks/use-opus"
import { IApiLog } from "contexts/opus/context"
import formatDate from "dateformat"

interface IProps {
  entityID: string
}

export const ApiLogTable: React.FC<IProps> = ({ entityID }) => {
  const [apiLogs, setApiLogs] = useState<IApiLog[]>([])

  const opus = useOpus()

  const { isFetching, refetch } = useQuery<IApiLog[] | undefined, AxiosError>(
    ["entity-api-logs"],
    async () => opus.apiLogClient.getAllForEntity(entityID) || [],
    {
      onSuccess: (result) => {
        if (result) {
          setApiLogs(result)
        }
      },
      enabled: !!entityID
    }
  )

  useEffect(() => {
    !entityID ? setApiLogs([]) : refetch()
  }, [entityID, refetch])

  return (
    <Table
      loading={isFetching}
      dataSource={apiLogs}
      pagination={{
        defaultPageSize: 50,
        hideOnSinglePage: true,
        position: ["bottomCenter"],
        size: "small"
      }}
    >
      <Column title="Url" dataIndex="url" />
      <Column
        title="Request Made At"
        dataIndex="dateTime"
        render={(date: string) =>
          `${formatDate(new Date(date), "dd-mm-yyyy HH:MM:ss")} (UTC)`
        }
      />
      <Column
        title="Response Received At"
        dataIndex="responseDateTime"
        render={(date: string) =>
          `${formatDate(new Date(date), "dd-mm-yyyy HH:MM:ss")} (UTC)`
        }
      />
      <Column title="HTTP Method" dataIndex="httpMethod" />
      <Column title="Request Body" dataIndex="requestBody" />
      <Column title="Response Body" dataIndex="responseBody" />
      <Column title="Request Headers" dataIndex="headers" />
      <Column title="Response Headers" dataIndex="responseHeaders" />
    </Table>
  )
}
